const throttle = {
    inserted(el, binding, vnode) {
        let timer
        console.log(binding);
        var key = Object.keys(binding.modifiers)

        el.addEventListener('click', function () {
            if (timer) return
            key.length > 0 ? binding.value(key[0]) : binding.value()
            timer = setTimeout(() => {
                clearTimeout(timer)
                timer = null
            }, binding.arg || 500)
        })
    },
}
export {
    throttle
}